import { createSlice } from '@reduxjs/toolkit';
import { getPolicy } from './policyAction';

const initialState = {
  policies: {}, // Cache policies by type: { PrivacyPolicy: { ... }, ... }
  isLoading: false,
  error: null,
};

const policySlice = createSlice({
  name: 'policy',
  initialState,
  reducers: {
    clearPolicyError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        const type = action.meta.arg;
        state.policies[type] = action.payload;
      })
      .addCase(getPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPolicyError } = policySlice.actions;
export default policySlice.reducer;
